/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通付加情報
 */
export interface Sgkb575aResCtrCommonAdditionalinformation {
    /** 
     * 契約満了予定年月：日付YYYYMM
     */
    contractexpireScheduledyearmonthdate?: string;
    /** 
     * 契約書番号：半角数字
     */
    ctrdocNo?: string;
    /** 
     * 契約締結日：日付YYYYMMDD
     */
    ctrConclusiondate?: string;
    /** 
     * 契約書受領日：日付YYYYMMDD
     */
    ctrdocReceiptdate?: string;
    /** 
     * 基本契約書番号：半角数字
     */
    basiccontractdocumentNo?: string;
    /** 
     * 基本契約締結日：日付YYYYMMDD
     */
    basiccontractdocumentConclusiondate?: string;
    /** 
     * 基本契約書受領日付：日付YYYYMMDD
     */
    basiccontractdocumentReceiptdate?: string;
    /** 
     * 基本契約年数：半角数値(小数点なし)
     */
    basiccontractNumberofyears?: number;
    /** 
     * 基本契約適用開始日：日付YYYYMMDD
     */
    basiccontractEffectivestartdate?: string;
    /** 
     * 初回検針年月：日付YYYYMM
     */
    firstInspectionyearmonthday?: string;
    /** 
     * お客さま契約窓口担当部署：全角文字
     */
    visitMadoguchiTantobusho?: string;
    /** 
     * お客さま契約窓口担当者：全角文字
     */
    visitMadoguchiTntsh?: string;
    /** 
     * お客さま契約窓口電話番号：電話番号(ハイフンと数値含む)
     */
    visitMadoguchiTelno?: string;
    /** 
     * 免税コード：半角英数混在
     */
    exmptaxCode?: string;
    /** 
     * 免税コード名称：全角半角混在
     */
    exmptaxCodeaname?: string;
    /** 
     * 免税種類コード：半角英数混在
     */
    exmptaxSyuruicode?: string;
    /** 
     * 免税種類コード名称：全角半角混在
     */
    exmptaxsyuruiCodeaname?: string;
    /** 
     * 基本契約更改フラグ：半角英数混在
     */
    basiccontractRenewalflag?: string;
    /** 
     * 基本契約更改フラグ名称：全角半角混在
     */
    basicCtrrenewalFlganame?: string;
}
